import { connect } from "react-redux";
import {reduxForm } from "redux-form";
import { compose } from "redux";
import React, { Component, Fragment } from "react";
import EnableProvider from "./EnableProvider.jsx";
import { openModal } from "../../modals/modalActions.jsx";
import classes from "./../Providers.module.css";

class Providers extends Component {
  state = {
    loadingInitial: true,
    agreementUrl: "",
    showModal: false,
    openManageUserPanel: false,
    selectedProvider: null,
    selectedRow: -1,
  };

  openEnableProviderPanelClasses = [classes.RevealMore];

  handleUserClick = (provider, index) => {
    if (this.props.profile.userType === "Merchant") {
      return;
    }
    this.setState({
      openEnableProviderPanel: true,
      selectedProvider: provider,
      selectedRow: index,
    });
  };

  handleCloseClick = () => {
    if (this.props.profile.userType === "Merchant") {
      return;
    }
    this.setState({
      openEnableProviderPanel: false,
      selectedProvider: null,
      selectedRow: -1,
    });
  };

  render() {
    let { selectedProvider, openEnableProviderPanel, selectedRow } = this.state;
    !selectedRow
      ? (this.transactionRowClasses = [classes.MerchantRow])
      : (this.transactionRowClasses = [
          classes.MerchantRow,
          classes.SelectedTransaction,
        ]);

    const providersList = [
      { id: "airtimeVoucher", provider: "Airtime Voucher", type: "Airtime" },
      { id: "airtimePinless", provider: "Airtime Pinless", type: "Airtime" },
      { id: "MultiChoice Botswana", provider: "DSTV payment", type: "DSTV" },
      { id: "WUC", provider: "Water Utilities Payment", type: "WUC" },
      { id: "BPC", provider: "Electricity", type: "BPC" },
      { id: "Gambling", provider: "Gambling", type: "Payments" },
      { id: "Botswana Life", provider: "Botswana Life", type: "Payments" },
      { id: "Assure Wealth", provider: "Assure Wealth", type: "Payments" },
      { id: "Badiphitlho", provider: "Badiphitlho", type: "Payments" },
    ];
    let providers =
      providersList &&
      providersList.map((provider, index) => {
        return (
          <tr
            className={
              this.state.selectedRow === index
                ? classes.SelectedTransaction
                : classes.MerchantRow
            }
            onClick={() => this.handleUserClick(provider, index)}
            key={provider.id}
          >
            <td>{provider.provider}</td>
            <td>{provider.type}</td>
          </tr>
        );
      });
    const buttonState = {
      state: undefined,
    };
    return (
      <Fragment>
        <div className={classes.MerchantTableWrapper}>
          <div className={classes.TableWrapper}>
            <table className={classes.MerchantTable}>
              <thead>
                <tr>
                  <th>Provider</th>
                  <th>Type</th>
                </tr>
              </thead>
              <tbody>{providers}</tbody>
            </table>
            {openEnableProviderPanel ? (
              <div className={classes.EnableUser}>
                <div className={classes.EnableUser}>
                  <div className={"card card-transparent"}>
                    <div
                      className={"card-header "}
                      style={{
                        padding: "0",
                        minHeight: "4.1rem",
                        padding: "1rem",
                        color: "#666",
                        fontSize: "1.4rem",
                        fontFamily: "Roboto",
                        fontWeight: "500",
                      }}
                    >
                      <div
                        className={"card-title semi-bold"}
                        style={{
                          color: "#666",
                          fontSize: "1.4rem",
                          fontFamily: "Roboto",
                          fontWeight: "500",
                          textTransform: "none",
                          marginLeft: "0.7rem",
                        }}
                      >
                        Manage Provider
                      </div>
                      <div className={"card-controls"}>
                        <ul>
                          <li>
                            <a
                              data-toggle="close"
                              className={"card-close"}
                              href="#"
                              onClick={this.handleCloseClick}
                            >
                              <i className={"card-icon card-icon-close"} />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className={"card-body"}>
                      <div className={"panel"}>
                        {selectedProvider ? (
                          <Fragment>
                            <ul
                              className={
                                "nav nav-tabs nav-tabs-simple d-none d-md-flex d-lg-flex d-xl-flex"
                              }
                            >
                              <li className={"nav-item active"}>
                                <a
                                  data-toggle="tab"
                                  href="#activation"
                                  className={"active show"}
                                >
                                  Manage Provider
                                </a>
                              </li>
                            </ul>
                            <div className={"tab-content"}>
                              <div
                                className={"tab-pane active"}
                                id="activation"
                              >
                                <div className={"row column-seperation"}>
                                  <div className={"col-md-12"}>
                                    <EnableProvider
                                      provider={selectedProvider}
                                      closePanel={this.handleCloseClick}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Fragment>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.async.loading,
  merchant: state.firestore.ordered.merchant[0],
  profile: state.firebase.profile,
  enableReinitialize: true,
});

const actions = {
  openModal,
};

export default compose(
  connect(mapStateToProps, actions),
  reduxForm({
    form: "registerEnableProvider",
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
    // validate,
  })
)(Providers);
